import OCard from './OCard'

export default OCard
